import PropTypes from 'prop-types'

import {
  CardStyled,
  EditPill,
  Header,
  HeaderAction,
  HeaderAside,
  HeaderContent,
  Heading,
} from './styles'

/**
 * Rounded card with an optional responsive header.
 *
 * `handleEdit`, `headerAside`, and `headerAction` are ignored unless `title` is provided.
 *
 * @param {object} props
 * @param {string} [props.title]
 * @param {function} [props.handleEdit]
 * @param {React.ReactNode} [props.headerAside] Content beside the title that can wrap below it.
 * @param {React.ReactNode} [props.headerAction] Content kept at the header's top right.
 * @param {React.ReactNode} [props.children]
 */
const RoundedCard = ({ title, handleEdit, headerAside, headerAction, children }) => {
  const hasAside = Boolean(headerAside)
  const hasAction = Boolean(headerAction)
  const collapseOnMobile = !hasAside && !hasAction

  return (
    <CardStyled>
      {title && (
        <Header $collapseOnMobile={collapseOnMobile}>
          <HeaderContent $collapseOnMobile={collapseOnMobile}>
            <Heading $collapseOnMobile={collapseOnMobile}>{title}</Heading>
            {hasAside && <HeaderAside>{headerAside}</HeaderAside>}
          </HeaderContent>
          {hasAction && <HeaderAction>{headerAction}</HeaderAction>}
          {handleEdit && (
            <EditPill
              $collapseOnMobile={collapseOnMobile}
              type='button'
              aria-label={`Edit ${title}`}
              onClick={handleEdit}>
              Edit
            </EditPill>
          )}
        </Header>
      )}
      {children}
    </CardStyled>
  )
}

RoundedCard.propTypes = {
  title: PropTypes.string,
  handleEdit: PropTypes.func,
  headerAside: PropTypes.node,
  headerAction: PropTypes.node,
  children: PropTypes.node,
}

export default RoundedCard
